import React from 'react';
import { useGetAttributesQuery } from '../../../../API/order/attributes/AttributesApi';
import { OrderAttributesSections } from './OrderAttributesSections';
import { Show } from '../../../shared/Show';
import { Spinner } from '../../../../ui-toolkit';
import { ErrorMessageTW } from '../../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../types/shared/UUID';

export const OrderAttributesContainer: React.FC<{ orderOpenDate: Date | string }> = ({ orderOpenDate }) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const {
    isLoading: isLoadingAttributes,
    data: attributesData,
    error: attributesError,
    isSuccess: isSuccessAttributes,
  } = useGetAttributesQuery(orderId);

  return (
    <div>
      <ErrorMessageTW rtkError={attributesError} />
      <Show when={isLoadingAttributes}>
        <Spinner />
      </Show>
      <Show when={isSuccessAttributes && !attributesError}>
        <OrderAttributesSections
          orderId={orderId}
          orderOpenDate={new Date(orderOpenDate)}
          attributes={attributesData}
        />
      </Show>
    </div>
  );
};
